<ul id="notifications_list" *ngIf="notifications.length" [@toastAnimation]>
	<li *ngFor="let notification of notifications" class="notification {{notification.state}}">
    	{{notification.message}}
	</li>
</ul>